import { render } from "./AppShell.vue?vue&type=template&id=6a30f899&ts=true"
import script from "./AppShell.vue?vue&type=script&lang=ts"
export * from "./AppShell.vue?vue&type=script&lang=ts"

import exportComponent from "/home/muhammadibrahim/Myserver/Pencil_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__